import { getStore } from '../store/store';
import getCurrentSubcategory from './getCurrentSubcategory';
export default function getCurrentSubcategoryLoadState() {
    return getStore().subCategoryLoadState.get(getCurrentSubcategory().key);
}
//# sourceMappingURL=getCurrentSubcategoryLoadState.js.map